<template>
    
    <div class="question-simu rangeField-simulator">
          
        <h2 class="question-simu__title">{{ questionDatas.title }}</h2>

        
        <div 
            class="question-simu__range-container"
        >
            <!-- Value -->
            <label :for="unit[`${questionDatas.key}`]" class="label">
                <div class="label__placeholder">{{ questionDatas.placeholder}}: </div>
                
                <div class="label__value">
                    {{ inputValue }} 
                    <span class="unit" v-html="unit[`${questionDatas.key}`]"></span>
                </div>
            </label>

            <!-- Input -->
            <input 
                :id="unit[`${questionDatas.key}`]"
                :list="unit[`${questionDatas.key}`]"
                class="range-style"
                type="range"
                min="10"
                max="400"
                step="1"
                @change="onValueChanged"
                v-model="inputValue"
            />

            <!-- Markers -->
            <ul v-if="markers.length > 1" class="markers-container">
                <li
                   v-for="(marker, index) in markers"
                   :key="index"
                >
                    {{ marker }}
                </li>
            </ul>
            
        </div>

    </div>
       
</template>

<script>

export default {
    name: "RangeQuestion",

    props: {
        questionDatas: {
            type: Object,
            default: {},
        },
        currentAnswer: {
            type: String,
            default: '',
        },
        markers: {
            type: Array,
            default: []
        }
    },


    data() {
        return {
            inputValue:this.currentAnswer || 50,
            unit: {
                mcp_housing_area: "m<small>2</small>",
            },
        };
    },

    methods: {
        onValueChanged() {
            this.$emit('Answer::choice', this.questionDatas.key, this.inputValue)
        }
    },

    created() {
        // So user can direct continue if value is good one
        this.$emit('Answer::choice', this.questionDatas.key, this.inputValue)
    },
    
    
}
</script>

<style lang="scss" scoped>
.question-simu__range-container {
    
    @include breakpoint(md) {
       margin: 100px auto;
       width: 80%;
    }
    
}

// LABEL
.label {
    display: flex;
    align-items: baseline;
    gap: 25px;
    margin: 50px 0;

    &__placeholder {
        font-size: 2rem;
    }

    &__value {
        font-family: $font-family-title-bold;
        font-size: 4rem;

        span.unit {
            font-size: 2.5rem;
        }
    }
}

// INPUT
input[type='range'] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:focus {
    outline: none;

    ~ ul li {
        color: $color-blue;

        &::before {
            background: $color-blue;
        }

    }
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  &::-moz-range-thumb {
    border: none;
  }
}

.range-style {
    cursor: pointer;
    width: 100%;
    height: 30px;
    background: $color-white;
    border-radius: 10px;

  @mixin track-style {
    display: flex;
    align-items: center;
    height: 10px;
    border-radius: 10px;
    box-shadow: inset -2px -2px 8px #ffffff, inset 2px 2px 8px rgba(black, 0.5);
  }

  @mixin thumb-style {
    cursor: grab;
    position: relative;
    top: 0;
    left: -5px;
    width: 20px;
    height: 30px;
    transform: translateY(-35%); 
    border: 4px solid #F44D57; 
    border-radius: 10px;
    background-color: transparent;
    backdrop-filter: blur(3px);
    //background-image: url(../../../assets/icons/mcp/Loader.svg);

    

    @include breakpoint(md) {
        left: 0px;
    }
  }

  &::-webkit-slider-runnable-track {
    @include track-style;
  }
  &::-webkit-slider-thumb {
    @include thumb-style;
  }
  &::-moz-range-track {
    @include track-style;
  }
  &::-moz-range-thumb {
    @include thumb-style;
  }
}

//MARKERS
  .markers-container {
    display: flex;
    justify-content: space-between;

    li {
        position: relative;
        padding: 15px 0;
        color: $color-gray-3;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            border-radius: 10px;
            height: 10px;
            width: 2px;
            background: $color-gray-3;
        }
    }
  }
</style>